// extracted by mini-css-extract-plugin
module.exports = {"ABRS":"RiverBaseH5_ABRS__smJ2X"};